// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/content-documents/media-document/sentiment/sentiment.menu.scss
// module id = 161
// module chunks = 0